{
  "de": {
    "levels": {
      "actions": {
        "add_customer": "Kunden hinzufügen",
        "cancel": "Rückgängig machen",
        "changeLevel": "Ebene ändern",
        "changeTargetGroup": "Zielgruppe ändern",
        "delete": "Löschen",
        "removeCustomer": "Kunden trennen",
        "requestUnits": "Einheiten anfordern",
        "save": "Speichern"
      },
      "building": "Gebäude",
      "customers": "Kunden",
      "descriptions": {
        "mupCantDelete": "Es sieht so aus, als hätten Sie noch Einheiten in diesem Projekt. Um das Projekt zu löschen, empfehlen wir Ihnen, zuerst die Einheiten zu löschen. So sind wir zu 100 % sicher, dass das Projekt gelöscht werden kann.",
        "mupCantDeleteDeactivate": "Eine Alternative zum Löschen des Projekts ist die Deaktivierung. So bleiben alle Informationen für eine zukünftige Nutzung erhalten. Möchten Sie dieses Projekt deaktivieren?"
      },
      "labels": {
        "activity": "Aktivität",
        "aftercare": "Nachbetreuung",
        "allLevels": "Alle Ebenen",
        "contacts": "Kontakte",
        "conversations": "Konversationen",
        "decisions": "Entscheidungen",
        "deleteProject": "Sind Sie sicher, dass Sie {project_name} löschen möchten",
        "deleteProjectDisclaimer": "Das Löschen dieses Projekts führt zum dauerhaften Verlust aller Daten und Inhalte. Diese Aktion ist unwiderruflich. Erwägen Sie alternativ, das Projekt zu deaktivieren, um alle Informationen für eine zukünftige Nutzung zu erhalten. Bitte gehen Sie mit Vorsicht vor.",
        "deleteWarning": "Vorsicht! Das Löschen dieser Ebene löscht alle untergeordneten Ebenen, Dokumente, Ankündigungen, FAQs und Aufgaben, die mit dieser Ebene verbunden sind.",
        "documents": "Dokumente",
        "download": "{level_name} herunterladen",
        "generatingExport": "Export wird erstellt",
        "hide": "Ausblenden",
        "information": "Informationen",
        "installment": "Finanzen",
        "milestones": "Meilensteine",
        "multiple_selection": "Mehrfachauswahl",
        "mupCantDelete": "Oh nein, diese Aktion ist nicht möglich!",
        "needMoreUnits": "Benötigen Sie weitere Einheiten?",
        "reachedMax": "Sie haben die Einheit erstellt, die diesem Projekt zugewiesen ist. | Sie haben die {count} Einheiten erreicht, die diesem Projekt zugewiesen sind.",
        "reachedMaxRundle": "Sie haben Ihr Limit von 1 aktiven Einheit erreicht. | Sie haben Ihr Limit von {count} aktiven Einheiten erreicht.",
        "requestMoreUnits": "Kontaktieren Sie das Ziggu-Team, wenn Sie weitere aktive Einheiten anfordern möchten.",
        "settings": "Projekteinstellungen",
        "sharedWith": "Geteilt mit ",
        "showForLevel": "{object} für Ebene anzeigen",
        "spaces": "Nebenflächen",
        "surveys": "Umfragen",
        "tickets": "Konversationen",
        "todos": "Aufgaben",
        "todos_v2": "Aufgaben v2",
        "willBeAssigned": "Verfügbar für alle in",
        "willBePublished": "Sichtbar für alle in",
        "willBeUploaded": "Wird hochgeladen in"
      },
      "lot": "Grundstück",
      "phase": "Phase",
      "project": "Projekt",
      "tooltip": {
        "unit_available": "Einheit ist noch verfügbar",
        "unit_reserved": "Einheit ist reserviert",
        "unit_sold": "Einheit ist verkauft"
      },
      "unit": "Einheit"
    }
  }
}
